import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=18b04cf0&"
import script from "./TableSettings.vue?vue&type=script&lang=js&"
export * from "./TableSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports